export const COMPONENT_NAME = "wallet-deposit";
